var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardOff = function SvgCreditCardOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "credit_card_off_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#credit_card_off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.775 18.925 20 17.15V12h-5.15l-4-4H20V6H8.85l-2-2H20q.824 0 1.413.588Q22 5.175 22 6v12q0 .25-.05.488a1.3 1.3 0 0 1-.175.437M9.15 12H4v6h11.15zM4 20q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4l2 2H4v2h1.15l-3.8-3.8q-.3-.3-.3-.712 0-.413.3-.713t.712-.3.713.3l18.4 18.4q.3.3.3.7t-.3.7-.713.3a.97.97 0 0 1-.712-.3L17.15 20z"
  }))));
};
export default SvgCreditCardOff;